// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./btn.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./loader.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./global.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../assets/fonts/dana/fontiran.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@fontsource/inter/100.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@fontsource/inter/200.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@fontsource/inter/300.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@fontsource/inter/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@fontsource/inter/500.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@fontsource/inter/600.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@fontsource/inter/700.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@fontsource/inter/800.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.2 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.visible{
  visibility: visible !important;
}
.static{
  position: static !important;
}
.fixed{
  position: fixed !important;
}
.absolute{
  position: absolute !important;
}
.relative{
  position: relative !important;
}
.sticky{
  position: sticky !important;
}
.bottom-0{
  bottom: 0px !important;
}
.bottom-2{
  bottom: 0.5rem !important;
}
.bottom-3{
  bottom: 0.75rem !important;
}
.bottom-5{
  bottom: 1.25rem !important;
}
.bottom-\\[-18px\\]{
  bottom: -18px !important;
}
.bottom-\\[118px\\]{
  bottom: 118px !important;
}
.bottom-\\[74px\\]{
  bottom: 74px !important;
}
.left-0{
  left: 0px !important;
}
.left-10{
  left: 2.5rem !important;
}
.left-2{
  left: 0.5rem !important;
}
.left-4{
  left: 1rem !important;
}
.left-\\[40px\\]{
  left: 40px !important;
}
.left-\\[45\\%\\]{
  left: 45% !important;
}
.left-\\[50\\%\\]{
  left: 50% !important;
}
.left-\\[50px\\]{
  left: 50px !important;
}
.left-\\[90px\\]{
  left: 90px !important;
}
.right-0{
  right: 0px !important;
}
.right-2{
  right: 0.5rem !important;
}
.right-3{
  right: 0.75rem !important;
}
.right-4{
  right: 1rem !important;
}
.right-\\[-20px\\]{
  right: -20px !important;
}
.right-\\[15px\\]{
  right: 15px !important;
}
.right-\\[40px\\]{
  right: 40px !important;
}
.right-\\[50px\\]{
  right: 50px !important;
}
.right-\\[60px\\]{
  right: 60px !important;
}
.top-0{
  top: 0px !important;
}
.top-1{
  top: 0.25rem !important;
}
.top-10{
  top: 2.5rem !important;
}
.top-\\[-2px\\]{
  top: -2px !important;
}
.top-\\[-30px\\]{
  top: -30px !important;
}
.top-\\[-32px\\]{
  top: -32px !important;
}
.top-\\[-6px\\]{
  top: -6px !important;
}
.top-\\[-95px\\]{
  top: -95px !important;
}
.top-\\[100px\\]{
  top: 100px !important;
}
.top-\\[10px\\]{
  top: 10px !important;
}
.top-\\[110px\\]{
  top: 110px !important;
}
.top-\\[120\\%\\]{
  top: 120% !important;
}
.top-\\[1px\\]{
  top: 1px !important;
}
.top-\\[4px\\]{
  top: 4px !important;
}
.top-\\[50\\%\\]{
  top: 50% !important;
}
.top-\\[64px\\]{
  top: 64px !important;
}
.z-10{
  z-index: 10 !important;
}
.z-20{
  z-index: 20 !important;
}
.z-\\[100\\]{
  z-index: 100 !important;
}
.z-\\[1\\]{
  z-index: 1 !important;
}
.z-\\[200\\]{
  z-index: 200 !important;
}
.z-\\[2\\]{
  z-index: 2 !important;
}
.z-\\[50\\]{
  z-index: 50 !important;
}
.z-\\[998\\]{
  z-index: 998 !important;
}
.z-\\[9999\\]{
  z-index: 9999 !important;
}
.z-\\[999\\]{
  z-index: 999 !important;
}
.col-span-1{
  grid-column: span 1 / span 1 !important;
}
.col-span-12{
  grid-column: span 12 / span 12 !important;
}
.col-span-2{
  grid-column: span 2 / span 2 !important;
}
.col-span-3{
  grid-column: span 3 / span 3 !important;
}
.col-span-4{
  grid-column: span 4 / span 4 !important;
}
.col-span-5{
  grid-column: span 5 / span 5 !important;
}
.col-span-6{
  grid-column: span 6 / span 6 !important;
}
.col-span-7{
  grid-column: span 7 / span 7 !important;
}
.col-span-9{
  grid-column: span 9 / span 9 !important;
}
.mx-1{
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}
.mx-2{
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}
.mx-3{
  margin-left: 0.75rem !important;
  margin-right: 0.75rem !important;
}
.mx-5{
  margin-left: 1.25rem !important;
  margin-right: 1.25rem !important;
}
.mx-7{
  margin-left: 1.75rem !important;
  margin-right: 1.75rem !important;
}
.mx-auto{
  margin-left: auto !important;
  margin-right: auto !important;
}
.my-1{
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.my-10{
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}
.my-2{
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.my-20{
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}
.my-3{
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.my-4{
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.mb-10{
  margin-bottom: 2.5rem !important;
}
.mb-2{
  margin-bottom: 0.5rem !important;
}
.mb-3{
  margin-bottom: 0.75rem !important;
}
.mb-5{
  margin-bottom: 1.25rem !important;
}
.mb-8{
  margin-bottom: 2rem !important;
}
.mb-\\[0\\.5px\\]{
  margin-bottom: 0.5px !important;
}
.mt-1{
  margin-top: 0.25rem !important;
}
.mt-10{
  margin-top: 2.5rem !important;
}
.mt-2{
  margin-top: 0.5rem !important;
}
.mt-20{
  margin-top: 5rem !important;
}
.mt-3{
  margin-top: 0.75rem !important;
}
.mt-4{
  margin-top: 1rem !important;
}
.mt-5{
  margin-top: 1.25rem !important;
}
.mt-6{
  margin-top: 1.5rem !important;
}
.mt-8{
  margin-top: 2rem !important;
}
.mt-\\[-4px\\]{
  margin-top: -4px !important;
}
.mt-\\[10px\\]{
  margin-top: 10px !important;
}
.mt-\\[4px\\]{
  margin-top: 4px !important;
}
.mt-\\[72px\\]{
  margin-top: 72px !important;
}
.block{
  display: block !important;
}
.flex{
  display: flex !important;
}
.grid{
  display: grid !important;
}
.hidden{
  display: none !important;
}
.h-\\[10px\\]{
  height: 10px !important;
}
.h-\\[116px\\]{
  height: 116px !important;
}
.h-\\[124px\\]{
  height: 124px !important;
}
.h-\\[144px\\]{
  height: 144px !important;
}
.h-\\[160px\\]{
  height: 160px !important;
}
.h-\\[16px\\]{
  height: 16px !important;
}
.h-\\[180px\\]{
  height: 180px !important;
}
.h-\\[18px\\]{
  height: 18px !important;
}
.h-\\[1px\\]{
  height: 1px !important;
}
.h-\\[200px\\]{
  height: 200px !important;
}
.h-\\[20px\\]{
  height: 20px !important;
}
.h-\\[22px\\]{
  height: 22px !important;
}
.h-\\[24px\\]{
  height: 24px !important;
}
.h-\\[260px\\]{
  height: 260px !important;
}
.h-\\[280px\\]{
  height: 280px !important;
}
.h-\\[28px\\]{
  height: 28px !important;
}
.h-\\[2px\\]{
  height: 2px !important;
}
.h-\\[300px\\]{
  height: 300px !important;
}
.h-\\[30px\\]{
  height: 30px !important;
}
.h-\\[320px\\]{
  height: 320px !important;
}
.h-\\[32px\\]{
  height: 32px !important;
}
.h-\\[36px\\]{
  height: 36px !important;
}
.h-\\[37px\\]{
  height: 37px !important;
}
.h-\\[380px\\]{
  height: 380px !important;
}
.h-\\[38px\\]{
  height: 38px !important;
}
.h-\\[40px\\]{
  height: 40px !important;
}
.h-\\[42px\\]{
  height: 42px !important;
}
.h-\\[44px\\]{
  height: 44px !important;
}
.h-\\[450px\\]{
  height: 450px !important;
}
.h-\\[46px\\]{
  height: 46px !important;
}
.h-\\[48px\\]{
  height: 48px !important;
}
.h-\\[50px\\]{
  height: 50px !important;
}
.h-\\[52px\\]{
  height: 52px !important;
}
.h-\\[64px\\]{
  height: 64px !important;
}
.h-\\[6px\\]{
  height: 6px !important;
}
.h-\\[72px\\]{
  height: 72px !important;
}
.h-\\[74px\\]{
  height: 74px !important;
}
.h-\\[80px\\]{
  height: 80px !important;
}
.h-\\[82px\\]{
  height: 82px !important;
}
.h-\\[92px\\]{
  height: 92px !important;
}
.h-full{
  height: 100% !important;
}
.h-min{
  height: min-content !important;
}
.h-screen{
  height: 100vh !important;
}
.max-h-\\[200px\\]{
  max-height: 200px !important;
}
.max-h-\\[240px\\]{
  max-height: 240px !important;
}
.max-h-\\[300px\\]{
  max-height: 300px !important;
}
.max-h-\\[92px\\]{
  max-height: 92px !important;
}
.min-h-\\[100px\\]{
  min-height: 100px !important;
}
.min-h-\\[108px\\]{
  min-height: 108px !important;
}
.min-h-\\[144px\\]{
  min-height: 144px !important;
}
.min-h-\\[200px\\]{
  min-height: 200px !important;
}
.min-h-\\[26px\\]{
  min-height: 26px !important;
}
.min-h-\\[300px\\]{
  min-height: 300px !important;
}
.min-h-\\[320px\\]{
  min-height: 320px !important;
}
.min-h-\\[36px\\]{
  min-height: 36px !important;
}
.min-h-\\[38px\\]{
  min-height: 38px !important;
}
.min-h-\\[40px\\]{
  min-height: 40px !important;
}
.min-h-\\[42px\\]{
  min-height: 42px !important;
}
.min-h-\\[46px\\]{
  min-height: 46px !important;
}
.min-h-\\[72px\\]{
  min-height: 72px !important;
}
.min-h-\\[740px\\]{
  min-height: 740px !important;
}
.min-h-\\[78px\\]{
  min-height: 78px !important;
}
.min-h-\\[92px\\]{
  min-height: 92px !important;
}
.w-\\[108px\\]{
  width: 108px !important;
}
.w-\\[10px\\]{
  width: 10px !important;
}
.w-\\[120px\\]{
  width: 120px !important;
}
.w-\\[124px\\]{
  width: 124px !important;
}
.w-\\[144px\\]{
  width: 144px !important;
}
.w-\\[148px\\]{
  width: 148px !important;
}
.w-\\[160px\\]{
  width: 160px !important;
}
.w-\\[16px\\]{
  width: 16px !important;
}
.w-\\[18px\\]{
  width: 18px !important;
}
.w-\\[1px\\]{
  width: 1px !important;
}
.w-\\[20\\%\\]{
  width: 20% !important;
}
.w-\\[200px\\]{
  width: 200px !important;
}
.w-\\[20px\\]{
  width: 20px !important;
}
.w-\\[22px\\]{
  width: 22px !important;
}
.w-\\[240px\\]{
  width: 240px !important;
}
.w-\\[24px\\]{
  width: 24px !important;
}
.w-\\[260px\\]{
  width: 260px !important;
}
.w-\\[30\\%\\]{
  width: 30% !important;
}
.w-\\[300px\\]{
  width: 300px !important;
}
.w-\\[30px\\]{
  width: 30px !important;
}
.w-\\[320px\\]{
  width: 320px !important;
}
.w-\\[33\\%\\]{
  width: 33% !important;
}
.w-\\[37px\\]{
  width: 37px !important;
}
.w-\\[420px\\]{
  width: 420px !important;
}
.w-\\[42px\\]{
  width: 42px !important;
}
.w-\\[48px\\]{
  width: 48px !important;
}
.w-\\[4px\\]{
  width: 4px !important;
}
.w-\\[50\\%\\]{
  width: 50% !important;
}
.w-\\[52px\\]{
  width: 52px !important;
}
.w-\\[60\\%\\]{
  width: 60% !important;
}
.w-\\[600px\\]{
  width: 600px !important;
}
.w-\\[64px\\]{
  width: 64px !important;
}
.w-\\[67\\%\\]{
  width: 67% !important;
}
.w-\\[6px\\]{
  width: 6px !important;
}
.w-\\[70\\%\\]{
  width: 70% !important;
}
.w-\\[72px\\]{
  width: 72px !important;
}
.w-\\[76\\%\\]{
  width: 76% !important;
}
.w-\\[80\\%\\]{
  width: 80% !important;
}
.w-\\[840px\\]{
  width: 840px !important;
}
.w-\\[85\\%\\]{
  width: 85% !important;
}
.w-\\[90\\%\\]{
  width: 90% !important;
}
.w-\\[92px\\]{
  width: 92px !important;
}
.w-\\[95\\%\\]{
  width: 95% !important;
}
.w-\\[98\\%\\]{
  width: 98% !important;
}
.w-full{
  width: 100% !important;
}
.w-max{
  width: max-content !important;
}
.w-min{
  width: min-content !important;
}
.w-screen{
  width: 100vw !important;
}
.min-w-\\[100px\\]{
  min-width: 100px !important;
}
.min-w-\\[144px\\]{
  min-width: 144px !important;
}
.min-w-\\[164px\\]{
  min-width: 164px !important;
}
.min-w-\\[200px\\]{
  min-width: 200px !important;
}
.min-w-\\[220px\\]{
  min-width: 220px !important;
}
.min-w-\\[240px\\]{
  min-width: 240px !important;
}
.min-w-\\[300px\\]{
  min-width: 300px !important;
}
.min-w-\\[320px\\]{
  min-width: 320px !important;
}
.min-w-\\[64px\\]{
  min-width: 64px !important;
}
.min-w-\\[820px\\]{
  min-width: 820px !important;
}
.min-w-\\[82px\\]{
  min-width: 82px !important;
}
.min-w-\\[92px\\]{
  min-width: 92px !important;
}
.min-w-full{
  min-width: 100% !important;
}
.max-w-\\[100\\%\\]{
  max-width: 100% !important;
}
.max-w-\\[1050px\\]{
  max-width: 1050px !important;
}
.max-w-\\[1164px\\]{
  max-width: 1164px !important;
}
.max-w-\\[1344px\\]{
  max-width: 1344px !important;
}
.max-w-\\[1364px\\]{
  max-width: 1364px !important;
}
.max-w-\\[240px\\]{
  max-width: 240px !important;
}
.max-w-\\[400px\\]{
  max-width: 400px !important;
}
.max-w-\\[420px\\]{
  max-width: 420px !important;
}
.max-w-\\[460px\\]{
  max-width: 460px !important;
}
.max-w-\\[480px\\]{
  max-width: 480px !important;
}
.max-w-\\[500px\\]{
  max-width: 500px !important;
}
.max-w-\\[600px\\]{
  max-width: 600px !important;
}
.max-w-\\[75\\%\\]{
  max-width: 75% !important;
}
.max-w-\\[85\\%\\]{
  max-width: 85% !important;
}
.max-w-\\[90\\%\\]{
  max-width: 90% !important;
}
.max-w-\\[92px\\]{
  max-width: 92px !important;
}
.max-w-none{
  max-width: none !important;
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-0{
  --tw-rotate: 0deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180{
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.cursor-not-allowed{
  cursor: not-allowed !important;
}
.cursor-pointer{
  cursor: pointer !important;
}
.cursor-progress{
  cursor: progress !important;
}
.select-all{
  -webkit-user-select: all !important;
          user-select: all !important;
}
.resize{
  resize: both !important;
}
.appearance-none{
  appearance: none !important;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-10{
  grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
}
.flex-row{
  flex-direction: row !important;
}
.flex-col{
  flex-direction: column !important;
}
.flex-col-reverse{
  flex-direction: column-reverse !important;
}
.flex-wrap{
  flex-wrap: wrap !important;
}
.items-start{
  align-items: flex-start !important;
}
.items-end{
  align-items: flex-end !important;
}
.items-center{
  align-items: center !important;
}
.items-stretch{
  align-items: stretch !important;
}
.justify-start{
  justify-content: flex-start !important;
}
.justify-end{
  justify-content: flex-end !important;
}
.justify-center{
  justify-content: center !important;
}
.justify-between{
  justify-content: space-between !important;
}
.justify-around{
  justify-content: space-around !important;
}
.justify-evenly{
  justify-content: space-evenly !important;
}
.gap-0{
  gap: 0px !important;
}
.gap-1{
  gap: 0.25rem !important;
}
.gap-2{
  gap: 0.5rem !important;
}
.gap-3{
  gap: 0.75rem !important;
}
.gap-4{
  gap: 1rem !important;
}
.gap-5{
  gap: 1.25rem !important;
}
.gap-6{
  gap: 1.5rem !important;
}
.gap-8{
  gap: 2rem !important;
}
.gap-x-4{
  column-gap: 1rem !important;
}
.gap-x-8{
  column-gap: 2rem !important;
}
.gap-y-2{
  row-gap: 0.5rem !important;
}
.gap-y-4{
  row-gap: 1rem !important;
}
.overflow-auto{
  overflow: auto !important;
}
.overflow-hidden{
  overflow: hidden !important;
}
.overflow-y-auto{
  overflow-y: auto !important;
}
.overflow-x-hidden{
  overflow-x: hidden !important;
}
.truncate{
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.break-words{
  overflow-wrap: break-word !important;
}
.break-all{
  word-break: break-all !important;
}
.rounded{
  border-radius: 0.25rem !important;
}
.rounded-\\[10px\\]{
  border-radius: 10px !important;
}
.rounded-\\[50\\%\\]{
  border-radius: 50% !important;
}
.rounded-lg{
  border-radius: 0.5rem !important;
}
.rounded-md{
  border-radius: 0.375rem !important;
}
.rounded-xl{
  border-radius: 0.75rem !important;
}
.rounded-b-md{
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}
.border{
  border-width: 1px !important;
}
.border-\\[1px\\]{
  border-width: 1px !important;
}
.border-\\[2px\\]{
  border-width: 2px !important;
}
.border-b{
  border-bottom-width: 1px !important;
}
.border-b-\\[1px\\]{
  border-bottom-width: 1px !important;
}
.border-b-\\[2px\\]{
  border-bottom-width: 2px !important;
}
.border-l-\\[1px\\]{
  border-left-width: 1px !important;
}
.border-l-\\[2px\\]{
  border-left-width: 2px !important;
}
.border-r-\\[2px\\]{
  border-right-width: 2px !important;
}
.border-dashed{
  border-style: dashed !important;
}
.border-none{
  border-style: none !important;
}
.border-\\[\\#0186D020\\]{
  border-color: #0186D020 !important;
}
.border-\\[\\#0186D060\\]{
  border-color: #0186D060 !important;
}
.border-black{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}
.border-d-background{
  --tw-border-opacity: 1 !important;
  border-color: rgb(10 12 23 / var(--tw-border-opacity)) !important;
}
.border-d-background-2{
  --tw-border-opacity: 1 !important;
  border-color: rgb(15 19 36 / var(--tw-border-opacity)) !important;
}
.border-gray-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}
.border-l-background-4{
  --tw-border-opacity: 1 !important;
  border-color: rgb(253 253 253 / var(--tw-border-opacity)) !important;
}
.border-l-main-2{
  --tw-border-opacity: 1 !important;
  border-color: rgb(66 66 66 / var(--tw-border-opacity)) !important;
}
.border-m-green{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 166 147 / var(--tw-border-opacity)) !important;
}
.border-m-green-border{
  border-color: #00A69360 !important;
}
.border-m-red{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 64 / var(--tw-border-opacity)) !important;
}
.border-m-red-border{
  border-color: #FF574060 !important;
}
.border-primary-blue{
  --tw-border-opacity: 1 !important;
  border-color: rgb(1 134 208 / var(--tw-border-opacity)) !important;
}
.border-secondary-blue{
  --tw-border-opacity: 1 !important;
  border-color: rgb(60 180 197 / var(--tw-border-opacity)) !important;
}
.border-b-primary-blue{
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgb(1 134 208 / var(--tw-border-opacity)) !important;
}
.bg-\\[\\#00A69360\\]{
  background-color: #00A69360 !important;
}
.bg-\\[\\#00A69380\\]{
  background-color: #00A69380 !important;
}
.bg-\\[\\#1D658D\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(29 101 141 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#3A3456F2\\]{
  background-color: #3A3456F2 !important;
}
.bg-\\[\\#3CB4C540\\]{
  background-color: #3CB4C540 !important;
}
.bg-black{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.bg-d-background{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(10 12 23 / var(--tw-bg-opacity)) !important;
}
.bg-d-hover{
  background-color: #ffffff14 !important;
}
.bg-gray-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}
.bg-gray-300{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity)) !important;
}
.bg-gray-400{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity)) !important;
}
.bg-gray-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity)) !important;
}
.bg-gray-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity)) !important;
}
.bg-green-active{
  background-color: #00A69340 !important;
}
.bg-l-background{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-l-background-2{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;
}
.bg-l-hover{
  background-color: #ffffff14 !important;
}
.bg-m-green{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 166 147 / var(--tw-bg-opacity)) !important;
}
.bg-m-green-border{
  background-color: #00A69360 !important;
}
.bg-m-red{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 87 64 / var(--tw-bg-opacity)) !important;
}
.bg-main-orange{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 120 45 / var(--tw-bg-opacity)) !important;
}
.bg-primary-blue{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(1 134 208 / var(--tw-bg-opacity)) !important;
}
.bg-red-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity)) !important;
}
.bg-secondary-blue{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(60 180 197 / var(--tw-bg-opacity)) !important;
}
.bg-slate-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity)) !important;
}
.bg-slate-800{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity)) !important;
}
.bg-slate-900{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity)) !important;
}
.bg-transparent{
  background-color: transparent !important;
}
.bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.p-0{
  padding: 0px !important;
}
.p-1{
  padding: 0.25rem !important;
}
.p-2{
  padding: 0.5rem !important;
}
.p-3{
  padding: 0.75rem !important;
}
.p-4{
  padding: 1rem !important;
}
.p-5{
  padding: 1.25rem !important;
}
.p-8{
  padding: 2rem !important;
}
.p-\\[1px\\]{
  padding: 1px !important;
}
.p-\\[4px\\]{
  padding: 4px !important;
}
.px-0{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.px-1{
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-10{
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}
.px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-5{
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.px-8{
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.py-0{
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.py-1{
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-10{
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}
.py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-3{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.py-4{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-5{
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.py-6{
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.py-8{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.py-\\[1px\\]{
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
.py-\\[6px\\]{
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.pb-10{
  padding-bottom: 2.5rem !important;
}
.pb-2{
  padding-bottom: 0.5rem !important;
}
.pb-20{
  padding-bottom: 5rem !important;
}
.pb-3{
  padding-bottom: 0.75rem !important;
}
.pb-4{
  padding-bottom: 1rem !important;
}
.pb-5{
  padding-bottom: 1.25rem !important;
}
.pb-8{
  padding-bottom: 2rem !important;
}
.pb-\\[48px\\]{
  padding-bottom: 48px !important;
}
.pb-\\[80px\\]{
  padding-bottom: 80px !important;
}
.pt-14{
  padding-top: 3.5rem !important;
}
.pt-2{
  padding-top: 0.5rem !important;
}
.pt-3{
  padding-top: 0.75rem !important;
}
.pt-5{
  padding-top: 1.25rem !important;
}
.pt-6{
  padding-top: 1.5rem !important;
}
.pt-8{
  padding-top: 2rem !important;
}
.pt-\\[144px\\]{
  padding-top: 144px !important;
}
.text-center{
  text-align: center !important;
}
.text-justify{
  text-align: justify !important;
}
.text-start{
  text-align: start !important;
}
.text-2xl{
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.text-2xs{
  font-size: 0.6rem !important;
}
.text-3xl{
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.text-\\[0\\.55rem\\]{
  font-size: 0.55rem !important;
}
.text-\\[0\\.6rem\\]{
  font-size: 0.6rem !important;
}
.text-\\[0\\.7rem\\]{
  font-size: 0.7rem !important;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem !important;
}
.text-\\[8px\\]{
  font-size: 8px !important;
}
.text-base{
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-lg{
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-xl{
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-xs{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.font-bold{
  font-weight: 700 !important;
}
.font-semibold{
  font-weight: 600 !important;
}
.uppercase{
  text-transform: uppercase !important;
}
.lowercase{
  text-transform: lowercase !important;
}
.leading-4{
  line-height: 1rem !important;
}
.tracking-wide{
  letter-spacing: 0.025em !important;
}
.text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.text-d-background-2{
  --tw-text-opacity: 1 !important;
  color: rgb(15 19 36 / var(--tw-text-opacity)) !important;
}
.text-d-main{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-gray-100{
  --tw-text-opacity: 1 !important;
  color: rgb(243 244 246 / var(--tw-text-opacity)) !important;
}
.text-gray-500{
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
}
.text-gray-600{
  --tw-text-opacity: 1 !important;
  color: rgb(75 85 99 / var(--tw-text-opacity)) !important;
}
.text-gray-900{
  --tw-text-opacity: 1 !important;
  color: rgb(17 24 39 / var(--tw-text-opacity)) !important;
}
.text-green-800{
  --tw-text-opacity: 1 !important;
  color: rgb(22 101 52 / var(--tw-text-opacity)) !important;
}
.text-l-main{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.text-l-main-2{
  --tw-text-opacity: 1 !important;
  color: rgb(66 66 66 / var(--tw-text-opacity)) !important;
}
.text-m-green{
  --tw-text-opacity: 1 !important;
  color: rgb(0 166 147 / var(--tw-text-opacity)) !important;
}
.text-m-red{
  --tw-text-opacity: 1 !important;
  color: rgb(255 87 64 / var(--tw-text-opacity)) !important;
}
.text-orange-500{
  --tw-text-opacity: 1 !important;
  color: rgb(249 115 22 / var(--tw-text-opacity)) !important;
}
.text-primary-blue{
  --tw-text-opacity: 1 !important;
  color: rgb(1 134 208 / var(--tw-text-opacity)) !important;
}
.text-red-500{
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity)) !important;
}
.text-secondary-blue{
  --tw-text-opacity: 1 !important;
  color: rgb(60 180 197 / var(--tw-text-opacity)) !important;
}
.text-slate-500{
  --tw-text-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-text-opacity)) !important;
}
.text-slate-900{
  --tw-text-opacity: 1 !important;
  color: rgb(15 23 42 / var(--tw-text-opacity)) !important;
}
.text-theme-toggle{
  --tw-text-opacity: 1 !important;
  color: rgb(60 180 197 / var(--tw-text-opacity)) !important;
}
.text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.underline{
  text-decoration-line: underline !important;
}
.caret-transparent{
  caret-color: transparent !important;
}
.opacity-100{
  opacity: 1 !important;
}
.opacity-20{
  opacity: 0.2 !important;
}
.opacity-30{
  opacity: 0.3 !important;
}
.opacity-60{
  opacity: 0.6 !important;
}
.opacity-80{
  opacity: 0.8 !important;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25) !important;
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-none{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.blur{
  --tw-blur: blur(8px) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.brightness-75{
  --tw-brightness: brightness(.75) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-blur-lg{
  --tw-backdrop-blur: blur(16px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-filter{
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-all{
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}

/*@font-face {*/
/*  font-family: "Vazir";*/
/*  src: url("../../assets/fonts/dana-fanum-regular.woff2");*/
/*  font-weight: normal;*/
/*  font-style: normal;*/
/*}*/

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: 'dana', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-transition: background-color 600000s 0s, color 600000s 0s;
  transition: background-color 600000s 0s, color 600000s 0s;
}


.custom-calendar.rmdp-wrapper,
.rmdp-container .custom-calendar.ep-arrow::after {
  background-color: #0A0C17 !important;
}

.custom-calendar .rmdp-month-picker{
  background-color: #0A0C17 !important;
}

.custom-calendar .rmdp-year-picker{
  background-color: #0A0C17 !important;
}

.rmdp-analog-clock{
  border: none !important;
  outline: 5px solid #09589e;
}

.rmdp-calendar-container-mobile {
  z-index: 9999999999999999 !important;
}

@media screen and (max-width: 1050px) {
  .rmdp-time-picker input {
    pointer-events:none;
  }

  .rmdp-arrow {
    width: 8px !important;
    height: 8px !important;
  }
}

::-webkit-scrollbar {
  width: 7px;
  height: 5px;
}


/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e6673;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #5e6673;
}

iframe#webpack-dev-server-client-overlay {
  display: none;
}

.placeholder\\:text-sm::placeholder{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}

.placeholder\\:text-xs::placeholder{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}

.hover\\:scale-\\[1\\.05\\]:hover{
  --tw-scale-x: 1.05 !important;
  --tw-scale-y: 1.05 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:bg-l-background-3:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 243 243 / var(--tw-bg-opacity)) !important;
}

.hover\\:bg-l-background-4:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity)) !important;
}

.hover\\:bg-primary-blue:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(1 134 208 / var(--tw-bg-opacity)) !important;
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

.hover\\:opacity-100:hover{
  opacity: 1 !important;
}

.hover\\:brightness-125:hover{
  --tw-brightness: brightness(1.25) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}

:is(.dark .dark\\:border-d-background-4){
  --tw-border-opacity: 1 !important;
  border-color: rgb(36 43 73 / var(--tw-border-opacity)) !important;
}

:is(.dark .dark\\:border-d-hover){
  border-color: #ffffff14 !important;
}

:is(.dark .dark\\:border-d-main-2){
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 217 217 / var(--tw-border-opacity)) !important;
}

:is(.dark .dark\\:border-l-background-2){
  --tw-border-opacity: 1 !important;
  border-color: rgb(250 250 250 / var(--tw-border-opacity)) !important;
}

:is(.dark .dark\\:border-m-green){
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 166 147 / var(--tw-border-opacity)) !important;
}

:is(.dark .dark\\:border-m-red){
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 64 / var(--tw-border-opacity)) !important;
}

:is(.dark .dark\\:border-primary-blue){
  --tw-border-opacity: 1 !important;
  border-color: rgb(1 134 208 / var(--tw-border-opacity)) !important;
}

:is(.dark .dark\\:border-slate-700){
  --tw-border-opacity: 1 !important;
  border-color: rgb(51 65 85 / var(--tw-border-opacity)) !important;
}

:is(.dark .dark\\:bg-d-background){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(10 12 23 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:bg-d-background-2){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(15 19 36 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:bg-d-hover){
  background-color: #ffffff14 !important;
}

:is(.dark .dark\\:bg-gray-100){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:bg-l-background){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:bg-primary-blue){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(1 134 208 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:bg-slate-600){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:bg-slate-700){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:bg-slate-800){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:text-d-main){
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

:is(.dark .dark\\:text-d-main-2){
  --tw-text-opacity: 1 !important;
  color: rgb(217 217 217 / var(--tw-text-opacity)) !important;
}

:is(.dark .dark\\:text-slate-400){
  --tw-text-opacity: 1 !important;
  color: rgb(148 163 184 / var(--tw-text-opacity)) !important;
}

:is(.dark .dark\\:text-slate-500){
  --tw-text-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-text-opacity)) !important;
}

:is(.dark .dark\\:text-white){
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

:is(.dark .dark\\:hover\\:bg-d-background-3:hover){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(26 32 53 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:hover\\:bg-d-background-4:hover){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(36 43 73 / var(--tw-bg-opacity)) !important;
}

@media (min-width: 640px){

  .sm\\:w-\\[62px\\]{
    width: 62px !important;
  }
}

@media (min-width: 1024px){

  .lg\\:visible{
    visibility: visible !important;
  }

  .lg\\:mx-0{
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .lg\\:mx-2{
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  .lg\\:my-2{
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .lg\\:mb-0{
    margin-bottom: 0px !important;
  }

  .lg\\:mt-0{
    margin-top: 0px !important;
  }

  .lg\\:mt-10{
    margin-top: 2.5rem !important;
  }

  .lg\\:mt-20{
    margin-top: 5rem !important;
  }

  .lg\\:mt-5{
    margin-top: 1.25rem !important;
  }

  .lg\\:mt-6{
    margin-top: 1.5rem !important;
  }

  .lg\\:mt-8{
    margin-top: 2rem !important;
  }

  .lg\\:block{
    display: block !important;
  }

  .lg\\:flex{
    display: flex !important;
  }

  .lg\\:grid{
    display: grid !important;
  }

  .lg\\:hidden{
    display: none !important;
  }

  .lg\\:h-\\[20px\\]{
    height: 20px !important;
  }

  .lg\\:h-\\[22px\\]{
    height: 22px !important;
  }

  .lg\\:h-\\[24px\\]{
    height: 24px !important;
  }

  .lg\\:h-\\[300px\\]{
    height: 300px !important;
  }

  .lg\\:h-\\[32px\\]{
    height: 32px !important;
  }

  .lg\\:h-\\[350px\\]{
    height: 350px !important;
  }

  .lg\\:h-\\[42px\\]{
    height: 42px !important;
  }

  .lg\\:h-\\[48px\\]{
    height: 48px !important;
  }

  .lg\\:h-\\[52px\\]{
    height: 52px !important;
  }

  .lg\\:h-\\[82px\\]{
    height: 82px !important;
  }

  .lg\\:h-\\[84px\\]{
    height: 84px !important;
  }

  .lg\\:max-h-\\[118px\\]{
    max-height: 118px !important;
  }

  .lg\\:min-h-\\[108px\\]{
    min-height: 108px !important;
  }

  .lg\\:w-\\[20px\\]{
    width: 20px !important;
  }

  .lg\\:w-\\[24px\\]{
    width: 24px !important;
  }

  .lg\\:w-\\[25\\%\\]{
    width: 25% !important;
  }

  .lg\\:w-\\[340px\\]{
    width: 340px !important;
  }

  .lg\\:w-\\[380px\\]{
    width: 380px !important;
  }

  .lg\\:w-\\[400px\\]{
    width: 400px !important;
  }

  .lg\\:w-\\[420px\\]{
    width: 420px !important;
  }

  .lg\\:w-\\[480px\\]{
    width: 480px !important;
  }

  .lg\\:w-\\[48px\\]{
    width: 48px !important;
  }

  .lg\\:w-\\[580px\\]{
    width: 580px !important;
  }

  .lg\\:w-\\[600px\\]{
    width: 600px !important;
  }

  .lg\\:w-\\[620px\\]{
    width: 620px !important;
  }

  .lg\\:w-\\[720px\\]{
    width: 720px !important;
  }

  .lg\\:w-\\[75\\%\\]{
    width: 75% !important;
  }

  .lg\\:w-max{
    width: max-content !important;
  }

  .lg\\:w-min{
    width: min-content !important;
  }

  .lg\\:min-w-\\[180px\\]{
    min-width: 180px !important;
  }

  .lg\\:min-w-\\[300px\\]{
    min-width: 300px !important;
  }

  .lg\\:min-w-\\[400px\\]{
    min-width: 400px !important;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .lg\\:flex-row{
    flex-direction: row !important;
  }

  .lg\\:flex-col{
    flex-direction: column !important;
  }

  .lg\\:items-start{
    align-items: flex-start !important;
  }

  .lg\\:items-center{
    align-items: center !important;
  }

  .lg\\:justify-end{
    justify-content: flex-end !important;
  }

  .lg\\:justify-center{
    justify-content: center !important;
  }

  .lg\\:justify-between{
    justify-content: space-between !important;
  }

  .lg\\:gap-0{
    gap: 0px !important;
  }

  .lg\\:gap-10{
    gap: 2.5rem !important;
  }

  .lg\\:gap-2{
    gap: 0.5rem !important;
  }

  .lg\\:gap-3{
    gap: 0.75rem !important;
  }

  .lg\\:gap-4{
    gap: 1rem !important;
  }

  .lg\\:gap-5{
    gap: 1.25rem !important;
  }

  .lg\\:gap-6{
    gap: 1.5rem !important;
  }

  .lg\\:gap-8{
    gap: 2rem !important;
  }

  .lg\\:gap-x-10{
    column-gap: 2.5rem !important;
  }

  .lg\\:gap-y-5{
    row-gap: 1.25rem !important;
  }

  .lg\\:gap-y-6{
    row-gap: 1.5rem !important;
  }

  .lg\\:border-secondary-blue{
    --tw-border-opacity: 1 !important;
    border-color: rgb(60 180 197 / var(--tw-border-opacity)) !important;
  }

  .lg\\:bg-l-hover{
    background-color: #ffffff14 !important;
  }

  .lg\\:p-2{
    padding: 0.5rem !important;
  }

  .lg\\:p-6{
    padding: 1.5rem !important;
  }

  .lg\\:p-8{
    padding: 2rem !important;
  }

  .lg\\:px-10{
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .lg\\:px-2{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  .lg\\:px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .lg\\:px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  .lg\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .lg\\:px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .lg\\:py-1{
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .lg\\:py-10{
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .lg\\:py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .lg\\:py-3{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .lg\\:py-4{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .lg\\:py-8{
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .lg\\:py-\\[6px\\]{
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }

  .lg\\:pb-0{
    padding-bottom: 0px !important;
  }

  .lg\\:pb-4{
    padding-bottom: 1rem !important;
  }

  .lg\\:pt-10{
    padding-top: 2.5rem !important;
  }

  .lg\\:text-center{
    text-align: center !important;
  }

  .lg\\:text-2xl{
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }

  .lg\\:text-\\[0\\.8rem\\]{
    font-size: 0.8rem !important;
  }

  .lg\\:text-base{
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .lg\\:text-lg{
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }

  .lg\\:text-sm{
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }

  .lg\\:text-xl{
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }

  .lg\\:text-xs{
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }

  .lg\\:font-bold{
    font-weight: 700 !important;
  }

  :is(.dark .lg\\:dark\\:bg-d-hover){
    background-color: #ffffff14 !important;
  }
}

@media (min-width: 1050px){

  .lp\\:mx-12{
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  .lp\\:my-0{
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  .lp\\:mt-2{
    margin-top: 0.5rem !important;
  }

  .lp\\:h-\\[24px\\]{
    height: 24px !important;
  }

  .lp\\:h-\\[52px\\]{
    height: 52px !important;
  }

  .lp\\:h-\\[58px\\]{
    height: 58px !important;
  }

  .lp\\:w-\\[24px\\]{
    width: 24px !important;
  }

  .lp\\:w-\\[480px\\]{
    width: 480px !important;
  }

  .lp\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lp\\:flex-row{
    flex-direction: row !important;
  }

  .lp\\:px-0{
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .lp\\:px-10{
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .lp\\:text-4xl{
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
  }

  .lp\\:text-\\[11px\\]{
    font-size: 11px !important;
  }

  .lp\\:text-base{
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .lp\\:text-sm{
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }

  .lp\\:text-xs{
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/css/index.css","<no source>"],"names":[],"mappings":"AAcA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wFAAmB;EAAnB,4GAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,0RAAmB;UAAnB;AAAmB;AAAnB;EAAA,0RAAmB;UAAnB;AAAmB;AAAnB;EAAA,2KAAmB;EAAnB,mKAAmB;EAAnB,4LAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAEnB,eAAe;AACf,0BAA0B;AAC1B,6DAA6D;AAC7D,yBAAyB;AACzB,wBAAwB;AACxB,IAAI;;AAEJ;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;;;;EASE,iEAAyD;EAAzD,yDAAyD;AAC3D;;;AAGA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;;AAGA,UAAU;AACV;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAhHA;EAAA,+BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,gCCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,6CCAA;EDAA;CCAA;;ADAA;EAAA,kCCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,gCCAA;EDAA;CCAA;;ADAA;EAAA,gCCAA;EDAA;CCAA;;ADAA;EAAA,gCCAA;EDAA;CCAA;;ADAA;EAAA,gCCAA;EDAA;CCAA;;ADAA;EAAA,gCCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;EAAA,8BCAA;EDAA;CCAA;;ADAA;;EAAA;IAAA;GCAA;CAAA;;ADAA;;EAAA;IAAA;GCAA;;EDAA;IAAA,4BCAA;IDAA;GCAA;;EDAA;IAAA,+BCAA;IDAA;GCAA;;EDAA;IAAA,8BCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kCCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,gCCAA;IDAA;GCAA;;EDAA;IAAA,gCCAA;IDAA;GCAA;;EDAA;IAAA,8BCAA;IDAA;GCAA;;EDAA;IAAA,iCCAA;IDAA;GCAA;;EDAA;IAAA,gCCAA;IDAA;GCAA;;EDAA;IAAA,8BCAA;IDAA;GCAA;;EDAA;IAAA,gCCAA;IDAA;GCAA;;EDAA;IAAA,+BCAA;IDAA;GCAA;;EDAA;IAAA,+BCAA;IDAA;GCAA;;EDAA;IAAA,gCCAA;IDAA;GCAA;;EDAA;IAAA,6BCAA;IDAA;GCAA;;EDAA;IAAA,6BCAA;IDAA;GCAA;;EDAA;IAAA,4BCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,6BCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,2BCAA;IDAA;GCAA;;EDAA;IAAA,+BCAA;IDAA;GCAA;;EDAA;IAAA,+BCAA;IDAA;GCAA;;EDAA;IAAA,8BCAA;IDAA;GCAA;;EDAA;IAAA,8BCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;CAAA;;ADAA;;EAAA;IAAA,6BCAA;IDAA;GCAA;;EDAA;IAAA,2BCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,6BCAA;IDAA;GCAA;;EDAA;IAAA,gCCAA;IDAA;GCAA;;EDAA;IAAA,8BCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,2BCAA;IDAA;GCAA;;EDAA;IAAA,+BCAA;IDAA;GCAA;;EDAA;IAAA,8BCAA;IDAA;GCAA;CAAA","sourcesContent":["@import \"btn.css\";\n@import \"loader.css\";\n@import \"global.css\";\n@import \"../../assets/fonts/dana/fontiran.css\";\n\n@import '../../../node_modules/@fontsource/inter/100.css';\n@import '../../../node_modules/@fontsource/inter/200.css';\n@import '../../../node_modules/@fontsource/inter/300.css';\n@import '../../../node_modules/@fontsource/inter/400.css';\n@import '../../../node_modules/@fontsource/inter/500.css';\n@import '../../../node_modules/@fontsource/inter/600.css';\n@import '../../../node_modules/@fontsource/inter/700.css';\n@import '../../../node_modules/@fontsource/inter/800.css';\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/*@font-face {*/\n/*  font-family: \"Vazir\";*/\n/*  src: url(\"../../assets/fonts/dana-fanum-regular.woff2\");*/\n/*  font-weight: normal;*/\n/*  font-style: normal;*/\n/*}*/\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: 'dana', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  transition: background-color 600000s 0s, color 600000s 0s;\n}\n\n\n.custom-calendar.rmdp-wrapper,\n.rmdp-container .custom-calendar.ep-arrow::after {\n  background-color: #0A0C17 !important;\n}\n\n.custom-calendar .rmdp-month-picker{\n  background-color: #0A0C17 !important;\n}\n\n.custom-calendar .rmdp-year-picker{\n  background-color: #0A0C17 !important;\n}\n\n.rmdp-analog-clock{\n  border: none !important;\n  outline: 5px solid #09589e;\n}\n\n.rmdp-calendar-container-mobile {\n  z-index: 9999999999999999 !important;\n}\n\n@media screen and (max-width: 1050px) {\n  .rmdp-time-picker input {\n    pointer-events:none;\n  }\n\n  .rmdp-arrow {\n    width: 8px !important;\n    height: 8px !important;\n  }\n}\n\n::-webkit-scrollbar {\n  width: 7px;\n  height: 5px;\n}\n\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #5e6673;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #5e6673;\n}\n\niframe#webpack-dev-server-client-overlay {\n  display: none;\n}\n\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
